import React from 'react';
import styles from './CategoryFilterPopover.module.scss';
import { LEADS_TOPBAR_ICON_GREY, dealsIconUnSelected } from '../../assets/hostedassets';
import { NotificationCategory } from './NotificationCenter.types';
import { NOTIFICATION_CATEGORY } from './NotificationCenter.constants';

interface Props {
    selected: Set<NotificationCategory>;
    onChange: (s: Set<NotificationCategory>) => void;
}

const ROWS: { key: NotificationCategory; label: string; icon: string }[] = [
    { key: NOTIFICATION_CATEGORY.LEAD, label: 'Lead', icon: LEADS_TOPBAR_ICON_GREY },
    { key: NOTIFICATION_CATEGORY.DEAL, label: 'Deals', icon: dealsIconUnSelected },
];

const CategoryFilterPopover: React.FC<Props> = ({ selected, onChange }) => {
    const toggle = (k: NotificationCategory) => {
        const next = new Set(selected);
        if (next.has(k)) next.delete(k);
        else next.add(k);
        onChange(next);
    };

    return (
        <div className={styles.Popover} role="menu" onClick={(e) => e.stopPropagation()}>
            {ROWS.map((row) => {
                const isChecked = selected.has(row.key);
                return (
                    <div
                        key={row.key}
                        className={styles.Row}
                        onClick={() => toggle(row.key)}
                        role="menuitemcheckbox"
                        aria-checked={isChecked}
                        tabIndex={0}
                    >
                        <div className={`${styles.CheckBox} ${isChecked ? styles.CheckBoxChecked : ''}`} aria-hidden="true" />
                        <img src={row.icon} alt="" className={styles.Icon} aria-hidden="true" />
                        <span className={styles.Label}>{row.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default CategoryFilterPopover;
